import { useMutation } from "@tanstack/react-query";
import { createExpert } from "../Api/expertForm";
import { ExpertFormState } from "../Models/expert";
import { AxiosError } from "axios";

export const useCreateExpert = () => {
  return useMutation<void, AxiosError, ExpertFormState>({
    mutationFn: (formState) => createExpert(formState),
  });
};
